import { render, staticRenderFns } from "./renderMenu.vue?vue&type=template&id=6a5a0719&scoped=true"
import script from "./renderMenu.vue?vue&type=script&lang=js"
export * from "./renderMenu.vue?vue&type=script&lang=js"
import style0 from "./renderMenu.vue?vue&type=style&index=0&id=6a5a0719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a0719",
  null
  
)

export default component.exports